"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
/**
 * @copyright
 * Copyright (c) 2023 Accretive Technology Group, Inc. All rights
 * reserved. For use only by Accretive Technology, its employees
 * and contractors. DO NOT DISTRIBUTE.
 */

var TableHeader = {
  styles: function styles(theme) {
    return {
      root: {
        borderWidth: 1,
        borderColor: theme.colors.baseContrast020,
        overflow: "hidden",
        textOverflow: "ellipsis",
        textTransform: "uppercase",
        fontFamily: 'Raleway, "Helvetica Neue", "Helvetica", "Arial", sans-serif',
        letterSpacing: 0.44,
        background: theme.colors.baseContrast010
      },
      sortIndicator: {
        margin: "1px 6px",
        // spacing around each sort arrow - top/bottom and left/right
        borderWidth: 3,
        // increase to make sort arrows wider
        borderBottomWidth: 5,
        // increase to make sort arrows taller
        borderBottomColor: theme.colors.baseContrast070 // sort arrows color
      },
      activeSortIndicator: {
        borderBottomColor: theme.colors.baseContrast085 // sort arrows color indicating sort direction
      }
    };
  }
};
var _default = exports.default = TableHeader;